export const MODULE_FILES = 'files';
export const MODULE_FEATURE_OPTIONS = 'feature_options';
export const MODULE_COMPANIES = 'companies';
export const MODULE_INFORMATION_SOURCES = 'information_sources';
export const MODULE_INFORMATION_SOURCE_SNAPSHOTS = 'information_source_snapshots';

export default {
  MODULE_FILES,
  MODULE_FEATURE_OPTIONS,
  MODULE_COMPANIES,
  MODULE_INFORMATION_SOURCES,
  MODULE_INFORMATION_SOURCE_SNAPSHOTS,
};
